import React from 'react';
import { connect } from 'react-redux';
import { fetchFMGFormModel } from './FMGFormBlock.action';
import FMGFormBlock from './FMGFormBlock.js';

class FMGFormBlockContainer extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchData(this.props.blockId);
    }
    render() {
        return (
            <FMGFormBlock {...this.props} />
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchData: (blockId) => dispatch(fetchFMGFormModel(blockId))
    }

}
const mapStateToProps = state => {
    return {
        result: state.FMGFormReducer.result
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FMGFormBlockContainer);